export default __webpack_public_path__ + "static/media/Unit_18_thumb.2d3e88f6.jpg";